import useSWR from "swr";
import { simpleFetcher } from "../fetcher";

interface OfficeOnlineUrl {
  officeOnlineUrl: string | null;
}

export function useOfficeOnlineUrl(documentVersionId?: number) {
  const url = documentVersionId
    ? `/api/v2/document-versions/${documentVersionId}/office-online-url`
    : null;

  const { data, error, isLoading } = useSWR<OfficeOnlineUrl, Error>(
    url,
    simpleFetcher,
    { revalidateOnFocus: false, revalidateOnMount: true },
  );

  return {
    officeOnlineUrl: data?.officeOnlineUrl ?? null,
    error,
    isLoading,
  };
}
